import React from "react";
import { useDialogKeyboard } from '../../../hooks/useDialogKeyboard';
import { Modal, ModalClose, ModalDialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/joy";

const DeleteTaskModal = ({ open, onClose, taskId, onConfirm }) => {
  useDialogKeyboard(open, { onEnter: onConfirm, onEscape: onClose });

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose onClick={onClose} />
        <DialogTitle>Archive Task</DialogTitle>
        <DialogContent>
          Are you sure you want to archive task {taskId}?
        </DialogContent>
        <DialogActions>
          <Button color="danger" onClick={onConfirm}>Archive</Button>
          <Button variant="plain" onClick={onClose}>Cancel</Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default DeleteTaskModal;

